/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Broker_PhotoInputs */

const cs_draft_broker_photo = /** @type {(inputs: Draft_Broker_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto makléře`)
};

const en_draft_broker_photo = /** @type {(inputs: Draft_Broker_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Broker photo`)
};

/**
* | output |
* | --- |
* | "Broker photo" |
*
* @param {Draft_Broker_PhotoInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const draft_broker_photo = /** @type {((inputs?: Draft_Broker_PhotoInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Broker_PhotoInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draft_broker_photo(inputs)
	return cs_draft_broker_photo(inputs)
});